import * as yup from "yup";

export const validationSchema = yup.object().shape({
  newGroup: yup.string().required("نام گروه کاربری را وارد کنید"),
});

export const initialValues = {
  newGroup: "",
};
